export const ALLOWED_NPI_QUERY_KEYS = {
  GET_ALLOWED_NPI: 'GET_ALLOWED_NPI',
}